import { Form, useLocation, useNavigation } from 'react-router'

import { localeOptions } from '@app/features/i18n/options'
import { useI18n } from '@app/utilities/i18n/provider'

export default function LanguageSwitcher() {
  const location = useLocation()
  const navigation = useNavigation()
  const { locale, t } = useI18n()
  const isSubmitting = navigation.state === 'submitting'
  const redirectTo = `${location.pathname}${location.search}${location.hash}`

  return (
    <Form method="post" className="flex items-center gap-2">
      <input type="hidden" name="intent" value="change_locale" />
      <input type="hidden" name="redirectTo" value={redirectTo} />
      <span className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">
        {t('shared.language.label')}
      </span>
      <div className="flex items-center gap-2">
        {localeOptions.map(option => {
          const isActive = option === locale

          return (
            <button
              key={option}
              type="submit"
              name="locale"
              value={option}
              disabled={isSubmitting}
              className={`rounded-full border px-3 py-1 text-xs font-medium transition ${
                isActive
                  ? 'border-zinc-900 bg-zinc-900 text-white'
                  : 'border-zinc-300 bg-white text-zinc-700 hover:border-zinc-500'
              }`}
            >
              {t(`shared.language.${option}`)}
            </button>
          )
        })}
      </div>
    </Form>
  )
}
